const EDITORIAL_EMAILS = new Set([
  "forumstoic+dev-editor@gmail.com",
  "forumstoic+prod-editor@gmail.com",
]);
const EDITORIAL_USER_IDS = new Set(["69ab2c712eb8208c0d974489"]);

export const isEditorialUserEmail = (email) =>
  EDITORIAL_EMAILS.has(String(email || "").trim().toLowerCase());

export const isEditorialUser = (user) =>
  isEditorialUserEmail(user?.email) ||
  EDITORIAL_USER_IDS.has(String(user?.id || user?._id || ""));
